import { combineReducers } from 'redux';
import { addingBulkGiftCardIssueConfigs } from './addingBulkGiftCardIssueConfigs';

export const giftCardConfigs = combineReducers({
  addingBulkGiftCardIssueConfigs
});
